// extracted by mini-css-extract-plugin
export default {"container":"AdminConfigTractorNozzles_container__EMrHr"};